import { Component, effect, inject, input } from '@angular/core';
import { AvatarService } from './avatar.service';

@Component({
  selector: 'ez-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  providers: [AvatarService],
  standalone: true,
  host: {
    '[style.background-color]': 'background',
    '[style.color]': 'color',
  },
})
export class AvatarComponent {
  protected readonly firstName = input<string>();
  protected readonly lastName = input<string>();

  background: string;
  color: string;

  initials = '';

  readonly #avatarService = inject(AvatarService);

  constructor() {
    effect(() => {
      this.#setStyles();
      this.#setInitials();
    });
  }

  #setStyles(): void {
    const avatar = this.#avatarService.getColor(`${this.firstName()} ${this.lastName()}`);

    this.background = avatar.background;
    this.color = avatar.color;
  }

  #setInitials(): void {
    this.initials = `${this.firstName()?.[0] || ''}${this.lastName()?.[0] || ''}`;
  }
}
